// extracted by mini-css-extract-plugin
export default {"label":"SponsoredLabel-module_label-HJ0z6","dark":"SponsoredLabel-module_dark-QyWF5"};